/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType } from '@/api/common'
import {
    getCustomerConversionPublicList,

    setCustomerConversion,
    setCustomerConversionBackByCustomerConversionId,
    getMarketClueSourceList,
    getCustomerConversion, customerConversionPublicExportData,
} from '@/api/customer'
import { TableHeader, TableRow } from './interface'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import realTimeSokcet from '@/utils/socket.io'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {delNullProperty} from "@/utils";
import CommonData from "@/utils/commonData";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class HighSeas extends Vue {
    // [x: string]: any
    socket: any = null
    tableHeadPopoverShow = false
    tableData: TableRow[] = []
    tableHeader: TableHeader[] = []
    checkTableRow: any = []
    tableHeadFilter = {
        marketClueSource: '',
        conversionName: '',
        marketClueName: '',
        weChat: '',
        marketClueDirectorUserIdList: [],
        directorUserIdList: [],
        leaderUserIdList: [],
        createdUserIdList: [], //客户接收人 2022-11-18
        status: '',
        isSign: '',
        level: '',
        intentionalityList: [],
        followAt: '',
        createdAt: '',
        eduTemandList: [],
        gradeList: [],
        attendSchool: '',
        specialized: '',
        targetSpecialized: '',
        followNum: '',
        publicAt: null,
        level2Scourse:[], // 二级来源,
        way :'',
        level2DepartmentId :'',
        directorLevel2DepartmentId :'',
        eduCode :'' , //客户编号
        region :'' , //所在城市
        marketClueSourceType :'' , //线索来源
        phone:''
    }
    followNumScopen = '' // 跟进次数范围
    followNumVal = '' // 跟进次数
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    // tableRandom = Math.random()
    receiverUser = ''
    editReceiverUserDialog = false
    sendBackDialog = false
    sendBackSelect = ''
    sendBackCause = ''
    sendBackOptions = [
        { value: '0', name: '退群' },
        { value: '1', name: '至少联系三次未联系上' },
        { value: '2', name: '非咨询科研项目' },
        { value: '3', name: '其他' }
    ]
    gradeOptions = CommonData.gradeList
    eduTemandOptions = [ '留学', '高考', '考研', '保研', '考博', '无升学需求', '待定' ,'就业','国内求职', '海外求职']
    intentionalityList =  [
        {label:'A',value:'A',interpretation:'（7天内签约）'},
        {label:'B',value:'B',interpretation:'（15天内签约）'},
        {label:'C',value:'C',interpretation:'（30天内签约）'},
        {label:'D',value:'D',interpretation:'（90天内签约）'},
        {label:'E',value:'E',interpretation:'（长期跟进）'},
        {label:'F',value:'F',interpretation:'（流失并调入公海）'},
        {label:'已签约',value:'已签约',interpretation:''},
    ]
    intentionalityName: any = {}
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    cancelTabkBackClueDialog = false
    cancelTabkBackClueId: number
    sendBackDialogConfirmButtonDisabled = false
    exportBUttonDisabled = false
    exportHeaderDialogVisible = false
    /*新增*/
    ClueSourceList: any = []
    source = ''
    sourcePage = 1
    sourceLimit = 20

    deadline: Date = null // 截止时间
    startDate: Date = null
    endDate: Date = null // 计算得出最后的结束时间为什么时候
    followDialog = false
    timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    datePickerOptions = {
        disabledDate: (v: Date) => (true),
    }
    time = ''
    selectValue = ''
    textValue = ''
    flag = false // 是否修改过时间没如果修改过就给后台传值
    isReceiveShow = false //都为1才显示批量跟进记录
    idList: any = [] //批量跟进id
    marketClueSourceList = []
    tableKey = Math.random()
    timer = null
    vdaH = 0 //屏幕高度
    originHeight: any = '' //屏幕高度
    heightScroll = false
    popHeight = 0
    draggableList = []
    draggableListChange = []
    dialogShow = false
    level2DepartmentList = [
        {name: '北京咨询部', id: 1047},
        {name: '上海咨询部', id: 1048},
        {name: '深圳咨询部', id: 1049},
        {name: '成都咨询部', id: 1065},
        {name: '广州咨询部', id: 1143},
        {name: '苏州咨询部', id: 1146}
    ]
    sourceList = [
        {name: '合作伙伴', val: 0},
        {name: '市场渠道', val: 1},
        {name: '其它', val: 2},
        {name: '高校', val: 3},
        {name: '分管', val: 4},
    ]
    exportButtonDisabled = false

    buttonShow = menuBtn
    // computed
    get userId() {
        return UserModule.userId
    }

    get arrfollowNumScopen(){
        const followNumScopen  = this.followNumScopen
        const followNumVal  = this.followNumVal
        return {
            followNumScopen ,followNumVal
        }
    }

    // created
    created() {
        this.getTableHeader()
        this.getMarketClueSourceList()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }
    mounted() {
        this.datePickerOptions.disabledDate = (v: Date) => {
            const emun = { '高': 1, '中': 3, '低': 7, }
            const nowtime = v.getTime()
            const starttime = new Date().setHours(0,0,0,0)
            const endtime = (new Date().getTime() + 1000 * 60 * 60 * 24 * emun[this.selectValue])
            this.startDate = new Date()

            if(!this.selectValue) {
                return true
            }
            if(this.selectValue === '已签约' || this.selectValue === '已拒绝' || this.selectValue === '暂无'|| this.selectValue === '已退群/拉黑') {
                return !(v.setHours(0,0,0,0) >= starttime)
            }
            this.endDate = new Date(endtime)
            return !(nowtime >= starttime && nowtime <= endtime)
        }
    }

    dialogCancle(){
        this.dialogShow = false
    }

    async dialogConfirm() {
         await getCustomerConversion({idList: this.idList})
        this.getTableData()
        this.$message.success('捞取成功')
        this.dialogShow = false

    }

    // methods
    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(17)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }


    // deadlineChange() {
    //     this.time = ''
    //     if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.startDate).setHours(0,0,0,0)) {
    //         this.timePickerOptions.start = `${this.startDate.getHours()}:${this.startDate.getMinutes()}`
    //         this.timePickerOptions.end = '23:59'
    //     } else if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.endDate).setHours(0,0,0,0)) {
    //         this.timePickerOptions.start = '00:00'
    //         this.timePickerOptions.end = `${this.endDate.getHours()}:${'00'}`
    //         // this.timePickerOptions.end = `${this.endDate.getHours()}:${this.endDate.getMinutes()}`
    //     } else {
    //         this.timePickerOptions.start = '00:00'
    //         this.timePickerOptions.end = '23:59'
    //     }
    // }


    async getTableData() {
        this.loading = true

        this.intentionalityName = this.tableHeadFilter.intentionalityList.map(item => {
            return item
        })
        // 跟进次数
        this.tableHeadFilter.followNum = this.followNumScopen + this.followNumVal
        const obj = this.removePropertyOfNull({
            ...this.tableHeadFilter,
            page: this.page,
            limit: this.limit
        })

        if(obj.followAt) obj.followAt = formatDate('yyyy-MM-dd', new Date(obj.followAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(obj.followAt[1]))
        if(obj.publicAt) obj.publicAt = formatDate('yyyy-MM-dd', new Date(obj.publicAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(obj.publicAt[1]))
        if(obj.createdAt) obj.createdAt = formatDate('yyyy-MM-dd', new Date(obj.createdAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(obj.createdAt[1]))

        const data: any = await getCustomerConversionPublicList(obj)

        this.tableData = data.customerConversionPublicList
        this.total = data.allNum
        this.tableKey = Math.random()

        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false

    }

    handleSelectionChange(arr: any) {
        this.checkTableRow = arr
        this.isReceiveShow = arr.every((item: any) => {
            return item.isReceive == 1
        })
        const idArr = []
        this.checkTableRow.map(item => {
            idArr.push(item.id)
        })
        this.idList = idArr
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/pubCustomerStatic')
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 17})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false

    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    clickLook(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/pubCustomerInfo?id=' + row.id)
        const time = setInterval(() => {
            if(win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    async receiveMarketClue(id: number) {
        await setCustomerConversion(id)
        this.$message.success('成功接收线索')
        this.getTableData()
    }


    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }


    clickFollow(row: any) {
        this.idList = [row.id]
        this.dialogShow = true
    }

    clickCancelBack(row) {
        this.cancelTabkBackClueId = row.id
        this.cancelTabkBackClueDialog = true
    }
    async confirmCancelTakeBackClue() {
        await setCustomerConversionBackByCustomerConversionId(this.cancelTabkBackClueId)
        this.$message.success('撤销回退线索成功')
        this.getTableData()
        this.cancelTabkBackClueDialog = false
    }

    // 退回线索
    sendBackclue(id: number) {
        this.sendBackClueID = id
        this.sendBackDialog = true
    }
    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }



    txtClassFun(row ) {
        let cla = ''
        if(row.followStatus === '2'){ //已超时
            cla = 'red-txt'
        }else if(row.followStatus === '1'){ //即将超时
            cla = 'orange-txt'
        }
        // const time = new Date().getTime()
        // let cla = ''
        // const date = new Date(row.followAt).getTime()
        // if(row.followIntentionality === '高') {
        //     const nextDate = 1000 * 60 * 60 * 24 + date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 ) cla = 'red-txt'
        // } else if(row.followIntentionality === '中') {
        //     const nextDate = 1000 * 60 * 60 * 24 * 3 +  date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 * 2 && nextDate - time > 1000 * 60 * 60 * 24) cla = 'orange-txt'
        //     if(nextDate - time <= 1000 * 60 * 60 * 24) cla = 'red-txt'
        // } else if(row.followIntentionality === '低') {
        //     const nextDate = 1000 * 60 * 60 * 24 * 7 +  date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 * 2 && nextDate - time > 1000 * 60 * 60 * 24) cla = 'orange-txt'
        //     if(nextDate - time <= 1000 * 60 * 60 * 24) cla = 'red-txt'
        // }
        return cla
    }


    @Watch('editReceiverUserDialog')
    handleWatchEditReceiverUserDialog(val: boolean) {
        if (val === false) {
            this.receiverUser = ''
        }
    }
    @Watch('sendBackDialog')
    handleWatchSendBackDialog(val: boolean) {
        if (val === false) {
            this.sendBackSelect = ''
            this.sendBackCause = ''
        }
    }
    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }


//    新增的
    async getMarketClueSourceList() {
        const data: any = await getMarketClueSourceList(
            {
                page: this.sourcePage,
                limit: this.sourceLimit,
                source: this.source
            }
        )
        this.ClueSourceList = data.marketClueSourceList
    }

    async handleClueSource() {
        if ((this.ClueSourceList.length == 0 || !this.source) && !this.tableHeadFilter.marketClueSource) {
            this.source = null
            this.sourcePage = 1
            // this.sourceLimit = 20
            const result: any = await getMarketClueSourceList(
                {
                    page: this.sourcePage,
                    limit: this.sourceLimit,
                    source: this.source
                }
            )
            this.ClueSourceList = result.marketClueSourceList
        }

    }

    handleClueSourceBlur(e) {
        this.source = null
        this.sourcePage = null
        this.sourceLimit = null
        this.getMarketClueSourceList()
    }

    async remoteMethod(query: any) {
        this.source = query
        this.sourcePage = 1
        this.sourceLimit = 20
        if (query !== '') {
            const result: any = await getMarketClueSourceList({
                page: this.sourcePage,
                limit: this.sourceLimit,
                source: query
            })
            this.ClueSourceList = result.marketClueSourceList
        } else {
              this.ClueSourceList = []
              this.getMarketClueSourceList()
        }
    }

    loadmore() {
        this.sourcePage = 1
        this.sourceLimit += 20
        this.getMarketClueSourceList();
    }

    clearClueSource() {
        this.tableHeadFilter.marketClueSource = ''
        this.source = null
        this.sourcePage = 1
        this.sourceLimit = 20
        this.getMarketClueSourceList()
    }

    changeClueSource(val) {
        // this.tableHeadFilter.marketClueSource = val
        this.marketClueSourceList = val
        this.page = 1
        this.getTableData()
    }

    changeCreateUserIdList(e){
        this.tableHeadFilter.createdUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changeMarketClueDirectorUserIdList(e){
        this.tableHeadFilter.marketClueDirectorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }
    changeLeaderUserIdList(e){
        this.tableHeadFilter.leaderUserIdList = e.id
        this.page = 1
        this.getTableData()
    }


    exportData(keys: string = '') {
        this.exportButtonDisabled = true

        const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit, keys })
        customerConversionPublicExportData(delNullProperty(obj)).then(() => {
            this.exportButtonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.exportButtonDisabled = false
        })

    }


    @Watch('arrfollowNumScopen')
    handlearrfollowNumScopen(nVal, oVal) {
        if ((nVal.followNumScopen && nVal.followNumVal)|| (!nVal.followNumScopen && !nVal.followNumVal) ){
            this.pageChange(1)
        }
    }
}
